import type { Book } from '../types';

export const PRICE_KEY_MULTIPLIER = 1e6;

export function getPriceKey(price: number | string): string | null {
  const num = Number(price);
  if (!isFinite(num)) return null;
  const scaled = Math.round(num * PRICE_KEY_MULTIPLIER);
  if (!Number.isFinite(scaled)) return null;
  return String(scaled);
}

export function setLevel(
  book: Book,
  isBid: boolean,
  priceStr: string | number,
  sizeStr: string | number
): void {
  const price = Number(priceStr);
  if (!isFinite(price)) return;
  const size = Number(sizeStr);
  const key = getPriceKey(price);
  if (key == null) return;
  const map = isBid ? book.bids : book.asks;
  // Update only the backing map. Sorting and price array rebuilding are deferred
  // to the render phase to minimize per-event work.
  if (!isFinite(size) || size <= 0) {
    if (map.has(key)) {
      map.delete(key);
    }
  } else {
    map.set(key, size);
  }
}
